<template>
  <v-container>
    <!-- Trigger Button -->
    <!-- <v-btn color="primary" dark @click="dialog = true"> فتح الحوار </v-btn> -->
    <v-icon color="red" @click="dialog = true">mdi-currency-usd</v-icon>
    <!-- Dialog -->
    <v-dialog v-model="dialog" max-width="">
      <v-card color="white">
        <!-- <v-card-title class="headline">تفاصيل العملية</v-card-title> -->
        <v-btn
          icon
          color="red"
          @click="dialog = false"
          style="position: absolute; top: 8px; left: 8px; z-index: 1"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card-text class="text-right">
          الاشتراك الشهرى للمجموعه : 1000 جنيه
          <br />

          <ValidationProvider
            v-slot="{ errors }"
            :name="$t('labels.subscriptions.subscription_value')"
            class="col-lg-6 m-auto"
            rules="required|numeric|min_value:0"
          >
            <base-input
              :name="$t('labels.subscriptions.subscription_value')"
              type="number"
              :placeholder="$t('labels.subscriptions.subscription_value')"
              v-model="data.subscription_value"
            />
            <span v-if="errors[0]" class="error--text d-inline-block">
              {{ errors[0] }}
            </span>
          </ValidationProvider>
          <!-- <v-checkbox
            v-model="data.isMonthSubscription"
            :label="`قيمه الشهر كامل: ${data.isMonthSubscription.toString()}`"
          ></v-checkbox> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            elevated
            class="px-6 py-2 text-white font-weight-bold"
            @click="assignSubscription()"
          >
            حفظ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      monthlyCost: 1000, // Monthly cost for the subscription
      data: {
        subscription_value: "",
        isMonthSubscription: false,
      },
    };
  },
  methods: {
    assignSubscription() {
      // Logic to assign subscription
      console.log(
        "Assigning subscription with data:",
        this.data.subscription_value
      );
      this.dialog = false; // Close dialog after assignment
      if (this.data.subscription_value < this.monthlyCost) {
        this.$swal({
          title: this.$t("labels.subscriptions.areYouSure"),
          text: this.$t("youWillNotBeAbleToGoBackInTheProcess"),
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: this.$t("no"),
          confirmButtonText: this.$t("yes"),
        }).then((result) => {
          console.log(result);
        });
      } else {
        // this.$emit("subscription-assigned", 0); // Emit 0 if no value is provided
        console.log(
          "Subscription assigned with value:",
          this.data.subscription_value
        );
      }
    },
  },
};
</script>

<style scoped>
.text-right {
  direction: rtl;
  text-align: right;
  font-size: 16px;
}
</style>
